import { Controller } from "@hotwired/stimulus"
import { fetchStream } from "../lib/stream_fetch"

// Polls the import status while it is running. Each response replaces this
// element, so a still-running import reconnects the controller and schedules
// the next poll, and a finished one renders with polling false and stops.
export default class extends Controller {
  static values = {
    url: String,
    polling: Boolean,
    interval: { type: Number, default: 2000 }
  }

  connect() {
    if (this.pollingValue) this.#schedule()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  #schedule() {
    this.timer = setTimeout(() => this.#poll(), this.intervalValue)
  }

  async #poll() {
    try {
      const response = await fetchStream(this.urlValue)
      if (!response) return

      if (response.ok) {
        // Replaces this element, which reconnects the controller (or not, once
        // the import is done). Nothing to schedule here.
        Turbo.renderStreamMessage(await response.text())
        return
      }
    } catch {
      // Falls through to reschedule.
    }

    // A dropped poll must not end the polling: without this the element is
    // never replaced, so nothing would reconnect the controller and the page
    // would sit on stale counts until a manual reload.
    this.#schedule()
  }
}
